/**
 * @generated SignedSource<<2392d98317ffb5fa1d9dbf69d02af323>>
 * @relayHash c71162808b0aaf43193218edf0425393
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2d6da81210d378d9b19f81d60b00cb6affccdfc19e1560d90980dc9c42a7e4b1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { EditCustomTemplateQueryParamModalQuery } from './EditCustomTemplateQueryParamModalQuery.graphql';

const node: PreloadableConcreteRequest<EditCustomTemplateQueryParamModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2d6da81210d378d9b19f81d60b00cb6affccdfc19e1560d90980dc9c42a7e4b1",
    "metadata": {},
    "name": "EditCustomTemplateQueryParamModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
